var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBobSecondary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "350.2258938222334 110.0142747161039 140.57346921806885 101.85244628158074",
    width: 136.57,
    height: 97.85,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M484.48 191.67L486.72 188.65L487.8 184.05L487.7 180.53L486.43 178.87L483.99 178.39L482.23 179.07L481.35 179.75L480.96 178.48L480.47 178.39L480.86 177.6L480.57 175.26L479.59 172.72L478.32 171.84L478.91 171.35L479.01 170.57L476.37 166.76L470.02 161.49L464.45 158.26L462.89 156.8L462.11 155.04L461.71 154.5L460.98 154.35L458.39 146.2L455.85 140.24L450.24 134.18L439.83 131.4L429.57 130.91L423.32 131.79L417.56 135.11L413.99 138.14L410.53 142.14L405.93 148.59L404.78 148.3L404.5 146.87L403.5 146.15L404.5 140.73L407.12 133.21L409.5 127.84L409.94 127.97L411.23 125.16L411.1 124.42L409.79 123.69L408.77 123.98L407.64 127.17L408.26 127.39L406.52 131.44L403.85 138.42L401.94 146.3L400.86 146.78L400.19 148.24L398.75 148.49L393.77 148.69L386.79 149.27L378.19 151.23L371.64 154.11L366.27 159.14L363.63 163L362.02 167.05L360.94 166.47L358.85 166.56L355.52 168.32L352.64 171.69L351.23 176.04L352.1 180.73L355.62 186.88L358.94 190.4L358.45 196.65L359.72 200.66L363.53 205.45L368.22 207.11L374.77 206.91L379.75 205.25L386.69 208.09L395.68 208.87L402.9 207.21L407.1 203.49L415.21 200.07L417.75 204.18L422.93 206.91L428.89 207.5L436.61 205.93L444.23 200.66L447.16 196.95L450.09 196.56L451.26 195.97L453.8 199.19L459.08 202.52L464.26 203.39L469.53 202.32L473.44 200.56L476.17 197.92L477.44 194.51L481.35 197.34L482.52 197.83L484.77 196.85L487.02 194.9L487.51 193.14L485.36 193.43L481.84 192.36L484.48 191.67Z",
    id: "a100OEwMOF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.82 172.26L476.6 174.67L476.86 177.25L477.28 178.03L478.19 178.74L479.3 178.81L480.14 177.76L480.14 176.07L479.46 173.79L478.39 172.36L477.6 172L476.82 172.26Z",
    id: "b7MaGQpl4w"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.66 193.63L368.22 197.44L372.62 200.17L374.87 202.52L377.5 204.27L378.87 204.76L374.87 205.93L370.86 206.33L365.88 205.45L362.17 202.12L360.12 198.02L359.33 193.92L359.72 191.28L362.66 193.63Z",
    id: "avK5iX3aP"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.17 184.5L403.3 185.28L402.84 186.4L401.34 186.26L402.2 184.5L403.17 184.5Z",
    id: "g13BaEI5Hy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.42 186.07L400.04 184.31L400.69 183.14L400.56 182.29L399.33 182.42L398.48 183.33L397.67 185.75L399.42 186.07Z",
    id: "b1bXBEEDsp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.54 185.55L397.3 182.23L397.95 181.06L397.82 180.21L396.58 180.34L395.74 181.25L393.79 185.23L395.54 185.55Z",
    id: "b4iKZzHtP0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.04 178.51L395.08 178.51L395.08 179.36L393.45 181.96L392.15 185.02L390.27 184.63L391.63 181.64L393.06 179.3L394.04 178.51Z",
    id: "a1LDvQATHD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.85 177.48L391.9 177.48L391.9 178.32L390.27 180.93L388.76 184.38L387.01 183.86L388.45 180.6L389.87 178.26L390.85 177.48Z",
    id: "h5T7v34WET"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.33 177.02L388.38 177.02L388.38 177.86L386.75 180.47L385.38 183.4L383.62 182.88L384.93 180.14L386.36 177.8L387.33 177.02Z",
    id: "a1LTS0pujx"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.86 182.55L383.56 179.36L384.34 177.93L383.95 177.27L382.71 177.41L381.86 178.32L379.98 181.9L381.86 182.55Z",
    id: "f4LbBDr7up"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.07 178.91L379.2 179.69L377.89 181.25L376.59 180.6L378.09 178.91L379.07 178.91Z",
    id: "b5BAsPxZvk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.79 193.24L477.64 193.77L480.28 195.63L482.08 196.85L484.14 195.82L485.8 194.8L486.33 193.92L485.94 193.82L485.11 194.21L483.99 194.65L483.74 194.46L484.62 194.06L484.87 193.77L482.87 193.24L480.38 192.36L479.15 191.92L477.83 191.18L477.79 192.01L477.79 193.24Z",
    id: "acQ7IZPoQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.3 191.23L481.79 191.77L484.53 190.6L486.53 186.79L487.07 183.08L486.72 180.34L485.31 179.17L483.01 179.41L480.57 181.51L478.96 185.27L478.42 189.33L479.3 191.23Z",
    id: "m1kRTDiEns"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.17 192.99L457.27 188.69L457.95 183.42L458.64 179.9L459.47 177.8L461.62 174.62L464.16 172.87L466.21 172.67L468.6 173.6L470.7 175.5L473.68 178.78L476.12 183.37L477 188.45L477 192.7L476.08 196.41L474.37 199.1L471.24 200.86L467.72 202.03L461.76 202.27L457.27 200.51L453.56 197.53L452.44 195.53L455.17 192.99Z",
    id: "bV9DBmVcL"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.79 195.29L428.89 192.45L431.53 190.11L433.38 186.98L433.38 184.05L432.11 182.2L436.51 178.19L440.61 174.09L442.57 172.92L446.38 172.72L449.31 173.7L450.97 176.43L451.36 180.34L450.19 186.4L447.06 194.41L444.62 198.22L440.03 202.61L433.19 205.84L426.84 206.52L421.47 205.25L417.95 202.71L416.48 199.58L424.79 195.29Z",
    id: "blq1WeuYs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.83 170.72L423.47 169.74L424.06 167.49L422.88 165.34L417.66 168.76L418.83 170.72Z",
    id: "amhQZG84U"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.21 166.32L406.91 169.69L403.29 174.53L401.78 178.29L401.88 181.41L403.69 184.1L407.15 185.47L412.28 184.2L418.68 180.58L422.69 176.04L424.2 172.67L424.59 170.08L422.74 172.57L419.66 174.23L415.8 174.04L412.77 172.28L411.55 169.5L412.19 166.81L414.97 164.61L411.21 166.32Z",
    id: "c5CNVdvsLg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.85 160.9L382.39 162.36L386.79 161.78L387.08 159.78L385.61 157.87L381.85 160.9Z",
    id: "j33XMiKoL0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.38 158.8L369.64 163.93L367 168.47L366.61 172.57L367.25 175.36L369.2 177.07L371.93 177.65L375.84 176.87L377.6 175.36L379.31 172.38L382.34 169.06L385.56 166.37L383.27 167.69L380.19 168.23L377.36 167.4L375.55 164.86L375.36 161.29L376.33 158.55L377.89 156.84L374.38 158.8Z",
    id: "c1sOa16tiz"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.3 170.67L357.58 168.03L359.72 167.2L361.82 167.88L362.22 169.84L363.19 173.11L366.61 176.77L378.14 182.73L387.81 185.57L401.73 187.37L406.86 186.93L414.09 184.15L419.8 181.02L423.52 180.14L426.3 179.9L428.89 180.68L431.48 182.93L432.5 185.37L432.11 187.96L429.72 191.04L423.47 194.7L417.61 197.78L413.11 200.03L409.45 201.39L410.28 200.12L410.67 199.24L409.79 199.34L405.15 204.47L401.24 206.81L393.14 207.79L384.39 206.08L376.14 201.78L372.03 197.58L370.96 194.94L370.23 193.33L368.96 192.7L368.47 192.94L369.15 193.92L370.08 195.09L371.15 197.63L366.56 195.14L358.55 189.23L355.03 184.64L352.25 178.87L352.49 174.04L354.3 170.67Z",
    id: "a1wgHUHkt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.85 167.64L363 168.96L363.53 171.11L364.9 173.4L365.78 174.58L365.44 171.45L366.71 167.25L370.08 162.32L374.62 157.63L378.97 155.23L381.95 154.5L384.54 154.89L386.88 156.7L388.2 159.39L388.3 161.49L387.91 164.47L392.84 160.85L399.44 157.28L408.86 153.86L415.65 152.11L416.05 152.2L410.62 153.82L403.93 156.26L394.94 160.8L386.64 166.86L380.97 171.55L378.97 174.58L377.65 177.12L377.8 178.04L378.92 178.24L381.36 177.12L386.54 176.24L391.47 176.72L395.63 178L399 179.95L400.56 180.88L400.8 177.75L403.1 173.21L407.84 167.69L412.97 164.47L418.05 162.66L421.42 162.9L424.06 164.71L425.37 167.35L425.28 172.33L423.03 176.92L420.93 179.7L423.37 179.12L427.52 179.12L430.45 180.73L431.28 181.51L432.65 180.83L437.05 176.33L442.81 171.45L445.99 169.84L448.38 169.64L450.48 170.86L451.26 173.4L451.16 175.36L451.8 176.92L452.04 181.56L451.07 186.59L448.97 192.11L447.4 195.82L450.53 195.58L452.92 193.97L455.32 190.84L456.73 186.3L457.32 180.53L459.32 176.19L462.3 173.01L464.21 171.69L465.67 171.55L467.28 172.04L468.46 172.77L469.43 173.16L471.93 175.6L474.61 179.31L476.76 183.32L477.4 186.35L477.59 190.01L477.88 186.49L478.76 183.61L480.13 180.98L480.72 180.24L480.42 179.22L478.67 179.41L477.44 178.92L476.47 177.7L476.12 174.04L476.22 171.99L476.86 171.25L478.03 171.01L478.27 170.67L477.1 168.47L474.46 165.74L468.75 161.24L463.96 158.46L462.25 156.55L461.91 155.33L461.47 154.94L461.23 155.43L460.69 156.26L459.32 156.65L453.8 156.84L449.7 156.21L444.81 154.84L438.61 152.5L432.9 151.03L427.23 150.74L419.22 150.74L411.99 150.54L405.54 149.66L403.78 148.88L403.69 148.25L403.32 147.68L402.46 148L400.36 148.54L397.07 148.78L390.62 149.17L384.83 150.1L380.39 151.01L376.48 152.42L371.18 155.14L368.71 157.33L365.76 160.51L363.9 164.03L363.27 166.03L362.85 167.64Z",
    id: "a19wsE5dsH"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.13 149.27L411.45 149.27L412.48 148.1L414.58 147.17L418.93 146.83L423.47 147.08L425.42 147.42L426.64 145.37L428.31 143.95L430.21 143.07L431.38 142.87L430.36 138.63L428.31 135.99L426.2 134.67L423.57 134.42L420.64 135.45L416.39 138.92L412.53 142.97L409.99 146.44L408.57 149.08L410.13 149.27Z",
    id: "a85wdyZj9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.3 148.88L408.13 148.88L410.08 145.51L413.02 141.7L417.07 137.75L419.46 135.84L421.71 134.52L425.33 133.15L430.06 133.15L433.87 134.47L437.24 136.87L439.15 140.19L440.03 144.34L439.93 148.59L439.78 152.11L441.44 152.98L441.15 150.1L441.15 145.76L441.39 140.38L442.32 137.55L444.37 135.89L447.36 136.33L450.63 139.26L454.73 146.59L455.85 152.06L456.34 156.01L458.44 156.16L459.96 155.87L460.45 155.04L458.39 147.95L456.39 143.17L453.51 138.58L449.75 134.91L444.08 133.01L437.05 131.74L431.97 131.49L426.25 131.93L421.27 133.5L416.09 136.72L412.33 140.82L408.81 145.32L406.52 148.69L407.3 148.88Z",
    id: "a1GBmD1JfH"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.38 133.69L431.24 134.28L434.07 135.4L436.02 137.06L435.39 139.06L434.75 141.21L434.41 143.07L432.9 142.73L432.07 142.68L431.48 140.38L430.31 137.4L428.79 135.45L426.84 134.18L424.45 133.94L427.38 133.69Z",
    id: "h6t4nB5Cvd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.5 144.1L430.26 144.58L429.43 144.53L428.94 144.83L428.84 145.32L428.21 145.51L427.47 145.95L427.47 146.39L427.03 146.68L426.69 147.22L426.79 147.56L430.84 148.15L431.28 146.24L431.33 143.9L430.5 144.1Z",
    id: "c6On4Uw7o"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.36 143.7L432.85 144L433.43 143.95L433.87 144L434.02 144.44L434.46 144.34L434.75 146.1L435.44 147.76L436.61 148.54L436.76 149.08L433.92 148.59L431.58 148.15L431.82 145.32L431.92 143.9L432.36 143.7Z",
    id: "d2TC8ZBahH"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.53 146.64L436.02 147.52L436.66 147.86L436.61 146.98L436.12 146.88L436.07 146.29L435.68 145.95L435.29 145.37L435.53 146.64Z",
    id: "d3JJHcf7Tb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.07 144.39L437.29 146.34L437.83 148.3L439.25 148.59L439.39 146.34L438.9 141.8L437.93 138.63L436.8 137.7L435.58 140.68L434.95 143.12L436.07 144.39Z",
    id: "cv7ybe4nZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.28 137.89L445.25 136.67L443.4 137.36L442.32 138.92L441.69 141.17L441.69 144.78L441.79 149.42L445.79 150.74L450.43 150.84L452.73 150.1L453.95 148.54L453.95 146.78L452.78 144.39L451.16 141.8L448.28 137.89Z",
    id: "b19xpq81rd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.08 152.84L446.13 154.6L451.7 156.11L455.51 156.01L455.41 154.6L455.07 150.93L454.39 149.13L453.56 150.15L451.85 151.13L448.18 151.77L444.47 151.23L441.74 150.05L442.08 152.84Z",
    id: "c49TqM6qZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.15 149.08L439.15 149.76L437.78 149.32L437.88 148.83L439.15 149.08Z",
    id: "a1qFVexvMx"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.39 176.63L359.97 178.34L359.77 180.53L360.26 182.88L360.31 180.1L360.7 179.17L362.8 181.07L367.3 183.66L372.43 186.54L376.72 190.65L382.68 197.53L388.3 202.12L391.38 203.05L395.33 202.61L400.95 199.68L408.57 194.51L413.41 192.06L417.61 190.35L423.22 186.98L424.98 184.98L425.72 183.56L426.4 184.15L426.79 185.37L426.6 186.4L427.43 185.52L427.43 184.2L426.45 183.42L424.45 182L423.13 181.56L424.1 182.29L425.08 183.17L424.84 184L423.66 185.47L420.25 187.81L414.73 190.06L409.65 191.23L398.27 191.62L384.69 191.87L379.95 190.21L375.16 187.03L370.13 184.1L364.76 181.22L362.07 179.31L361.19 178.09L361.92 177.07L362.8 176.33L361.39 176.63Z",
    id: "f35FB0U4uH"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.25 193.77L407.5 194.31L410.23 192.75L412.72 191.57L408.81 192.21L407.15 192.36L407.25 193.77Z",
    id: "a2fuZOnl1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.73 195.53L399.97 198.07L400.31 199.24L404.22 196.75L407.1 194.75L406.67 193.24L406.62 192.31L402.71 192.6L399.97 192.89L399.73 195.53Z",
    id: "clmWQzFqe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.23 195.78L391.13 199.05L391.77 202.17L393.96 202.12L396.8 201.2L399.83 199.63L399.24 196.6L399.34 194.16L399.34 192.89L394.99 192.94L391.67 193.14L391.23 195.78Z",
    id: "bfPzrRsCS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.98 192.85L391.04 192.99L390.5 196.85L390.64 199.73L391.08 202.22L387.86 201.1L384.88 198.46L383.27 196.65L383.9 192.45L386.98 192.85Z",
    id: "a1IE7MrcsO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.68 191.38L383.27 192.26L382.93 194.51L382.73 196.41L380.48 193.97L378.04 190.79L377.16 189.28L380.68 191.38Z",
    id: "d2JkDiTu6l"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.91 202.27L371.55 199L372.43 199.98L373.3 201.73L375.06 204.37L372.91 202.27Z",
    id: "deZhUi8NR"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.98 202.03L368.61 197.34L369.49 198.32L371.06 202.52L372.52 204.76L369.98 202.03Z",
    id: "alvqDdEdS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.66 201.93L365.39 197.92L365.29 194.99L365.88 195.39L366.27 198.9L367.73 202.42L369.2 204.67L366.66 201.93Z",
    id: "c8Wuk6SZI2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.68 197.83L363.73 202.32L366.95 204.67L364.8 202.61L363.14 199.19L362.26 195.39L362.46 193.04L361.39 192.36L361.68 197.83Z",
    id: "d4DZguDwCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.83 201.05L457.32 198.41L455.27 195.39L454.58 192.85L454.97 191.67L455.27 193.92L456.83 196.95L459.67 199.49L463.18 201.73L460.83 201.05Z",
    id: "a3y3iPoPH8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.35 199.98L460.83 196.65L458.59 192.94L457.61 190.69L459.17 194.99L461.91 198.71L465.04 201.05L467.19 200.76L464.35 199.98Z",
    id: "bihWGFgy1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.07 199.39L464.45 196.75L461.13 191.97L459.96 188.35L462.11 192.75L465.72 197.05L468.65 198.71L470.8 199.39L468.07 199.39Z",
    id: "c2iqmQR1q2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.17 201.69L418.44 199.98L418.24 197.97L418.93 197.58L418.93 200.12L419.61 201.88L420.39 203.05L419.17 201.69Z",
    id: "c1nDpfu5VX"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.91 201.88L421.32 199.78L421.12 197.68L421.27 196.41L421.96 196.02L421.61 198.46L421.86 200.71L422.44 202.17L422.98 203.1L421.91 201.88Z",
    id: "e43J7G9E2M"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.15 197.29L424.4 199.63L425.08 201.64L426.55 203.25L425.52 201.83L424.88 200.07L424.69 198.32L424.74 196.31L425.08 194.55L424.4 195.14L424.15 197.29Z",
    id: "fgEqr12EN"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.57 197.09L427.52 200.03L427.96 201.54L428.84 202.61L427.52 201.2L427.03 198.41L427.28 195.58L427.82 192.99L428.6 192.65L427.57 197.09Z",
    id: "fMip0bvDJ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.92 189.43L434.61 193.19L434.75 196.65L436.46 198.02L438.66 197.48L443.64 193.19L446.77 188.69L448.48 184.79L448.28 182.49L446.72 181.22L444.13 181.27L441.39 183.12L439.39 184.79L435.92 189.43Z",
    id: "biyuS0NzT"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.22 187.81L436.17 191.38L435.58 194.41L436.07 196.36L437.68 196.9L439.59 196.12L442.86 192.94L441.15 193.63L439.98 192.75L439.93 190.74L441.44 187.86L442.52 187.08L443.45 186.74L442.32 188.11L441.59 189.67L441.49 191.04L441.79 192.11L442.71 192.21L444.42 190.74L445.69 188.35L445.5 187.37L445.06 186.79L445.64 186.93L445.99 187.33L446.96 185.18L446.91 183.47L445.99 182.1L443.98 182.2L442.13 183.66L440.91 184.64L438.22 187.81Z",
    id: "agRBgMq9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.6 179.36L463.77 182.59L464.3 185.96L466.45 189.82L469.48 191.62L472.75 191.09L474.27 189.23L474.07 185.18L472.41 180.88L469.68 178.24L467.24 178.04L465.92 178.29L464.6 179.36Z",
    id: "dksc5WLCu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.01 187.52L468.41 190.11L471.09 190.6L473 189.13L473.54 186.64L472.36 182.49L470.61 180L468.12 178.92L465.87 179.12L464.74 181.37L464.84 184.1L466.01 187.52Z",
    id: "b2bUc1NVt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.07 184.83L469.33 185.91L470.41 186.59L471.83 185.91L471.58 183.61L470.41 181.95L468.99 181.61L468.21 182.05L467.97 183.37L468.07 184.83Z",
    id: "c15U28PieX"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.5 184L469.48 185.22L470.56 185.66L471.29 185.03L471.05 183.42L470.26 182.29L469.29 182L468.65 182.2L468.46 183.08L468.5 184Z",
    id: "afy84xuaA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.91 167.84L410.48 163.29L417.75 159.04L422.88 156.75L429.28 154.65L432.7 153.96L427.52 154.6L420.34 157.09L414.33 160.07L407.74 164.07L403.54 168.08L401.68 170.57L400.85 172.43L404.91 167.84Z",
    id: "ebs1wD9Kf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.83 161.13L453.9 162.62L454.16 164.77L454.61 166.66L456.37 167.38L458.72 167.44L460.48 166.86L461.33 165.69L461.26 163.01L460.54 160.61L458.85 159.69L455.85 159.56L454.61 159.95L453.83 161.13Z",
    id: "fcoscEzXK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.93 167.74L446.28 166.86L447.7 166.76L448.09 167.49L448.48 168.37L448.67 167.49L448.53 166.76L449.36 167.01L450.72 168.13L452.14 169.98L452.73 172.08L452.58 170.38L451.8 168.52L450.34 166.76L448.62 165.93L448.72 163.39L448.33 160.17L447.26 158.16L445.55 156.45L447.16 158.95L447.89 161.73L447.94 164.66L447.84 165.78L445.35 166.27L442.52 167.79L440.76 169.59L443.93 167.74Z",
    id: "k1QszdfR22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.49 162.23L454.81 163.54L456.05 164.32L457.74 164.32L459.82 163.86L460.67 163.21L460.35 161.64L458.85 160.47L456.7 160.15L455.2 160.41L454.61 161.13L454.49 162.23Z",
    id: "f2YNy00Qv6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.24 147.05L401.92 146.64L403.1 146.55L403.82 146.96L404.31 147.68L404.04 147.82L403.59 147.32L402.64 147.36L401.83 147.64L401.01 147.73L401.24 147.05Z",
    id: "b2bIAz8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.01 139.33L406 133.67L407.85 129.27L408.61 127.55L409.15 127.64L407.59 131.06L405.41 136.85L403.68 143.48L403.1 146.03L402.43 146.07L404.01 139.33Z",
    id: "h6J3Lxa1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.96 124.59L409.39 124.16L410.25 124.27L410.75 124.85L410.62 125.38L409.86 127.19L409.35 126.65L408.86 126.48L408.17 126.71L408.96 124.59Z",
    id: "ajRAKmwAK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.78 175.6L443.06 174.48L443.98 174.38L442.47 174.43L439.88 175.11L437.19 176.77L437.05 177.41L439.78 175.6Z",
    id: "ac0Xami2l"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.73 180.39L435.92 178.68L433.78 181.81L432.75 183.61L432.41 182.93L433.73 180.39Z",
    id: "h2yM6lKDT"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.28 131.96L436.63 132.23L441.99 133.24L445.93 134.26L448.91 135.35L443.01 133.99L438.74 133.31L436.97 133.58L435.21 132.7L431 132.23L426.93 132.23L431.28 131.96Z",
    id: "c52OYJDToS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.5 154.88L431.61 155.16L427.95 156.1L423.34 157.87L420.62 159.09L417.1 160.99L423.74 158.82L426.86 157.73L429.85 156.78L433.38 156.1L437.58 156.24L440.16 156.24L440.98 155.7L436.5 154.88Z",
    id: "eaE0yxxf5y"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.7 150.41L394.16 149.73L400.41 149.59L396.34 150.54L390.91 150.95L384.12 151.76L380.6 152.44L377.48 153.26L380.46 151.9L386.7 150.41Z",
    id: "khHeby3Jh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.69 180.53L422.79 180.87L426.19 181.34L428.49 182.29L430.46 184.06L431.14 184.67L430.53 182.9L427.34 180.87L424.69 180.53Z",
    id: "b1IYnnxW8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.41 182.74L414.15 184.65L410.18 186.18L413.43 185.55L416.51 183.92L418.86 182.66L420.31 181.57L417.41 182.74Z",
    id: "e2URkqvb57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.11 170.01L358.41 168.38L360.18 168.52L361.33 169.88L362.01 171.78L362.35 173.34L360.85 171.1L359.16 170.08L357.87 170.15L356.04 171.03L354.27 172.93L356.11 170.01Z",
    id: "aieNZzIR1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.82 196.61L432.49 198.71L434.6 200.61L437.31 200.95L439.89 199.18L443.08 195.86L440.23 197.69L437.31 199.18L434.87 198.78L433.72 197.08L433.31 194.3L433.38 192.6L432.36 194.44L431.82 196.61Z",
    id: "a9DYLsoKG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.97 192.24L471.32 192.33L473.77 191.34L474.94 189.35L474.94 187.09L475.48 189.62L474.85 192.6L473.49 193.69L470.96 193.87L468.16 192.69L466.08 190.89L468.97 192.24Z",
    id: "a2SQHH73H1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.1 180.94L446.29 180.45L448.26 181.48L448.89 182.47L448.44 180.21L445.09 179.31L441.93 180.12L439.94 183.02L443.1 180.94Z",
    id: "cUCHIciEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.41 178.22L462.73 179.94L462.68 181.89L463.72 179.31L465.53 177.72L467.3 177.32L469.21 177.69L470.43 178.23L468.52 176.96L466.35 176.64L465.22 176.96L463.41 178.22Z",
    id: "aARNB0e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.14 189.48L482.83 189.42L484.39 188.47L485.62 187.31L484.53 189.62L483.04 190.5L480.87 191.11L479.58 189.96L479.17 188.6L479.31 187.18L479.58 188.33L481.14 189.48Z",
    id: "cwXuGQ2l"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.09 181.48L358.62 186.36L363.41 190.25L367.12 192.33L368.57 194.14L368.84 195.32L363.95 192.42L359.43 188.72L355.81 184.19L353.64 180.21L353.28 177.32L355.09 181.48Z",
    id: "abqJpldj6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.28 206.26L396.06 206.54L402.03 205.36L405.56 203.01L407.01 201.02L402.39 203.82L397.78 205.36L392.54 205.54L387.92 205.09L382.95 204L389.28 206.26Z",
    id: "f1yO8CaXdi"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.81 189.8L424.56 192.33L418.77 195.41L414.43 197.49L411.8 198.57L411.46 199.92L416.98 197.39L423.02 194.23L428.18 191.25L429.62 189.35L430.89 187L428.81 189.8Z",
    id: "b1BLALiyGh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.18 170.28L463.72 169.15L466.4 169.45L469.24 170.72L470.21 171.84L469.24 170.03L467.92 169.3L464.6 168.52L462.45 169.01L460.4 170.47L459.27 172.28L461.18 170.28Z",
    id: "d7F40RQX9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.39 161.13L462.43 165.1L462.89 167.84L463.08 166.08L462.5 162.62L461.19 159.49L459.24 157.41L459.43 158.19L461.39 161.13Z",
    id: "baFVOqfbj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.38 159.23L467.7 161.19L470.35 163.16L473.88 166.01L475.78 168.11L472.18 165.47L467.98 162.41L464.72 160.24L463.09 158.68L462.35 157.39L464.38 159.23Z",
    id: "bquqRZPp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.5 193.35L436.43 195.18L437.52 195.79L439.21 195.39L440.91 194.1L438.33 194.5L437.24 193.55L437.04 191.04L436.5 193.35Z",
    id: "dEgeu8qRt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.01 180.46L466.89 179.71L468.66 179.78L470.35 180.73L468.59 180.53L467.03 180.66L466.21 182.02L465.6 183.38L465.47 182.16L466.01 180.46Z",
    id: "c1Q1HsGIMu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.99 188.94L471.03 189.48L471.98 188.81L472.66 187.52L472.66 186.16L471.98 187.72L470.69 188.47L468.99 188.33L467.7 187.79L468.99 188.94Z",
    id: "dag6wyWxm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.35 158.55L379.55 155.88L382.31 155.43L384.53 155.97L385.93 157.01L386.29 157.78L381.23 158.55L375.8 160L372.41 160.99L372.64 160.54L374.35 158.55Z",
    id: "a168GNXIia"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.86 160.9L378.24 159.45L382.99 159L385.93 158.73L388.92 157.33L388.65 156.78L386.02 157.82L382.31 158.32L379.24 158.59L376.12 159.18L372.95 160.49L369.92 161.85L369.02 162.39L369.42 163.34L370.26 162.69L373.86 160.9Z",
    id: "g2ocEyLNWF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.27 165.13L421.1 166.35L424.56 168.38L423.74 166.08L422.05 164.31L419.95 163.36L417.37 163.43L416.15 163.91L419.27 165.13Z",
    id: "abPRDOvk0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.67 164.48L419.93 166.28L423.8 169.07L426.19 170.81L429.36 171.72L429.51 171.13L426.85 170.18L423.73 168.11L421.24 166.29L418.51 164.68L415.26 163.58L412.09 162.6L411.05 162.41L410.73 163.39L411.79 163.45L415.67 164.48Z",
    id: "czlF72qZ7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.7 181.28L484.53 181.41L485.68 182.5L486.23 183.31L486.02 181.48L485.21 180.19L483.72 179.85L482.02 180.87L481.21 182.02L482.7 181.28Z",
    id: "b203FYOTXp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.83 140.44L391.44 138.5L388.22 137.3L384.32 134.98L380.91 131.29L379.53 127.69L379.43 123.64L381.15 119.87L383.77 117.98L386.61 117.76L388.63 118.21L389.51 118.75L390.8 117.26L393.49 116.14L397.91 116.29L401.28 118.34L402.96 121.97L402.98 125.91L400.28 130.79L397.45 134.83L396.05 137.9L395.75 139.5L394.98 140.77L393.83 140.44Z",
    id: "hoocz4s4Q"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.44 118.69L385.1 118.56L382.88 119.58L380.72 122.47L379.98 126.23L380.96 129.45L382.66 132.19L386.13 135.24L389.58 137.05L392.12 138.1L393.91 139.36L394.7 139.72L395.22 139.14L395.65 136.86L397.25 134.25L400.39 129.47L402.11 125.33L401.94 121.59L400.23 118.5L396.39 116.67L392.63 117.14L390.05 119.34L389.01 121.66L388.89 122.82L388.25 122.63L388.38 120.74L388.81 119.61L387.44 118.69Z",
    id: "b2lhgW6BpA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.93 125.66L367.42 124.66L366.52 123.79L365.56 122.44L364.96 120.7L365.03 119.29L365.59 117.92L366.72 116.92L367.88 116.67L368.86 117.02L369.47 117.47L369.69 117.78L370.34 117.47L371.4 117.49L372.85 118.19L373.68 119.38L373.71 120.84L373.13 122.16L371.51 123.39L369.97 124.32L369.04 125.14L368.71 125.63L368.26 125.94L367.93 125.66Z",
    id: "b1YgGhd65q"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369 117.44L368.24 117.05L367.34 117.07L366.2 117.71L365.39 118.86L365.25 120.08L365.41 121.25L366.12 122.78L367.01 123.89L367.7 124.62L368.11 125.31L368.32 125.54L368.58 125.43L369.06 124.73L369.98 124.09L371.74 122.95L372.92 121.83L373.42 120.55L373.3 119.27L372.29 118.09L370.96 117.69L369.78 118.04L369.09 118.67L368.88 119.04L368.69 118.88L369.01 118.26L369.32 117.95L369 117.44Z",
    id: "b1hXbSTLaz"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.28 112.15L421.98 111.01L418.78 111.1L416.41 112.7L414.63 115.95L414.95 119.59L417.39 123.74L418.33 125.85L418.47 127.31L419.28 127.96L420.54 127.1L422.46 126.64L426.95 125.98L429.81 124.91L431.88 122.67L432.72 119.81L431.84 116.72L429.65 114.73L427.21 113.9L425.51 114.1L424.28 112.15Z",
    id: "aenm9wvXP"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.68 113.49L422.9 111.88L420.09 111.65L417.68 112.53L415.85 114.58L415.33 118.25L416.71 121.61L418.28 124.33L419 126L419.14 126.98L420.37 126.42L424.15 125.85L428.16 124.87L430.32 123.63L431.74 121.09L431.75 118.22L430.29 115.99L428.25 114.72L426.71 114.43L425.74 114.65L426.07 115.31L426.13 116.24L425.33 115.92L424.68 113.49Z",
    id: "b1S5DFe3h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.37 137.05L364.3 136.09L366.99 136.14L368.98 137.47L370.5 140.2L370.25 143.26L368.22 146.76L367.43 148.53L367.32 149.76L366.65 150.31L365.59 149.59L363.98 149.22L360.2 148.68L357.79 147.8L356.04 145.92L355.32 143.53L356.04 140.93L357.88 139.25L359.92 138.53L361.35 138.69L362.37 137.05Z",
    id: "b89vliFkR"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.04 138.18L363.53 136.82L365.89 136.61L367.92 137.34L369.47 139.05L369.92 142.13L368.78 144.96L367.47 147.25L366.88 148.66L366.76 149.49L365.72 149.02L362.55 148.56L359.17 147.76L357.36 146.73L356.15 144.6L356.12 142.19L357.34 140.31L359.05 139.23L360.34 138.98L361.16 139.16L360.88 139.71L360.84 140.5L361.51 140.23L362.04 138.18Z",
    id: "d1rfFOpYgW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.65 159.59L442.83 160.67L439.39 161.04L439.21 160.49L442.65 159.59Z",
    id: "f99bhBsJyt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.47 139.69L360.47 140.19L359.84 140.86L358.75 140.86L357.76 141.5L357.03 142.58L356.76 144.03L356.49 142.81L356.99 141.45L357.85 140.28L359.02 139.51L359.93 139.51L360.47 139.69Z",
    id: "bOZCff5gB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.59 137.47L364.81 137.15L366.21 137.2L367.62 137.88L367.71 138.83L366.39 139.19L365.53 138.69L364.5 138.24L363.27 138.38L362.23 139.24L362.55 138.47L363.59 137.47Z",
    id: "b1MkoFiOop"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.17 113.97L423.71 114.41L422.52 114.43L421.55 113.43L420.08 113.08L418.43 113.38L416.86 114.42L417.74 113.08L419.44 112.33L421.29 112.07L423.04 112.47L423.85 113.3L424.17 113.97Z",
    id: "h417XxseJ3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.53 118.28L429.93 118.49L428.84 118.02L428.37 116.71L427.59 115.58L426.28 114.9L426.91 114.83L428.69 115.36L430.13 116.45L430.52 117.55L430.53 118.28Z",
    id: "eNM8x55t0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.43 119.83L388.2 120.5L387.03 121.11L385.58 120.6L383.95 120.99L382.48 122.1L381.44 123.91L381.64 122.15L382.95 120.57L384.64 119.4L386.58 118.91L387.79 119.34L388.43 119.83Z",
    id: "apHjeM8Yx"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.59 117.48L395.65 117.35L397.89 117.85L399.94 119.37L399.8 120.92L397.57 121.1L396.35 120.04L394.81 118.99L392.81 118.84L390.87 119.9L391.62 118.76L393.59 117.48Z",
    id: "dTLRutKyV"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.81 117.79L368.67 118.04L368.17 118.21L367.63 117.92L366.96 117.97L366.3 118.32L365.78 118.98L365.97 118.29L366.58 117.74L367.33 117.38L368.13 117.31L368.58 117.55L368.81 117.79Z",
    id: "cbeiabNzm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.97 118.01L371.67 118.18L372.36 118.57L372.88 119.29L372.67 119.79L371.92 119.62L371.62 119.14L371.22 118.64L370.57 118.38L369.81 118.53L370.18 118.23L370.97 118.01Z",
    id: "btaCazh2x"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a100OEwMOF",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a100OEwMOF",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1.36,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b7MaGQpl4w",
    opacity: 1,
    fill: "#f2f2f2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b7MaGQpl4w",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#avK5iX3aP",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#avK5iX3aP",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g13BaEI5Hy",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g13BaEI5Hy",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1bXBEEDsp",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1bXBEEDsp",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4iKZzHtP0",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4iKZzHtP0",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1LDvQATHD",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1LDvQATHD",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h5T7v34WET",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h5T7v34WET",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1LTS0pujx",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1LTS0pujx",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f4LbBDr7up",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f4LbBDr7up",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b5BAsPxZvk",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b5BAsPxZvk",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#acQ7IZPoQ",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#acQ7IZPoQ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m1kRTDiEns",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m1kRTDiEns",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bV9DBmVcL",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bV9DBmVcL",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#blq1WeuYs",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#blq1WeuYs",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#amhQZG84U",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#amhQZG84U",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c5CNVdvsLg",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c5CNVdvsLg",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j33XMiKoL0",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j33XMiKoL0",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1sOa16tiz",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1sOa16tiz",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1wgHUHkt",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1wgHUHkt",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a19wsE5dsH",
    opacity: 1,
    fill: "#119a9a",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a19wsE5dsH",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a85wdyZj9",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a85wdyZj9",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1GBmD1JfH",
    opacity: 1,
    fill: "#119a9a",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1GBmD1JfH",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h6t4nB5Cvd",
    opacity: 1,
    fill: "#f2f2f2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h6t4nB5Cvd",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c6On4Uw7o",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c6On4Uw7o",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d2TC8ZBahH",
    opacity: 1,
    fill: "#f2f2f2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d2TC8ZBahH",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d3JJHcf7Tb",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d3JJHcf7Tb",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cv7ybe4nZ",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cv7ybe4nZ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b19xpq81rd",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b19xpq81rd",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c49TqM6qZ",
    opacity: 1,
    fill: "#f2f2f2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c49TqM6qZ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1qFVexvMx",
    opacity: 1,
    fill: "#595959",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1qFVexvMx",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f35FB0U4uH",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f35FB0U4uH",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2fuZOnl1F",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2fuZOnl1F",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#clmWQzFqe",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#clmWQzFqe",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bfPzrRsCS",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bfPzrRsCS",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1IE7MrcsO",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1IE7MrcsO",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d2JkDiTu6l",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d2JkDiTu6l",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#deZhUi8NR",
    opacity: 1,
    fill: "#f2f2f2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#deZhUi8NR",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#alvqDdEdS",
    opacity: 1,
    fill: "#f2f2f2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#alvqDdEdS",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c8Wuk6SZI2",
    opacity: 1,
    fill: "#f2f2f2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c8Wuk6SZI2",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d4DZguDwCA",
    opacity: 1,
    fill: "#f2f2f2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d4DZguDwCA",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3y3iPoPH8",
    opacity: 1,
    fill: "#f2f2f2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3y3iPoPH8",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bihWGFgy1",
    opacity: 1,
    fill: "#f2f2f2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bihWGFgy1",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2iqmQR1q2",
    opacity: 1,
    fill: "#f2f2f2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2iqmQR1q2",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1nDpfu5VX",
    opacity: 1,
    fill: "#f2f2f2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1nDpfu5VX",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e43J7G9E2M",
    opacity: 1,
    fill: "#f2f2f2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e43J7G9E2M",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fgEqr12EN",
    opacity: 1,
    fill: "#f2f2f2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fgEqr12EN",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fMip0bvDJ",
    opacity: 1,
    fill: "#f2f2f2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fMip0bvDJ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#biyuS0NzT",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#biyuS0NzT",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#agRBgMq9Z",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#agRBgMq9Z",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dksc5WLCu",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dksc5WLCu",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2bUc1NVt",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2bUc1NVt",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c15U28PieX",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c15U28PieX",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#afy84xuaA",
    opacity: 1,
    fill: "#f2f2f2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#afy84xuaA",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ebs1wD9Kf",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ebs1wD9Kf",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fcoscEzXK",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fcoscEzXK",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k1QszdfR22",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k1QszdfR22",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f2YNy00Qv6",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f2YNy00Qv6",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2bIAz8F4",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2bIAz8F4",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h6J3Lxa1",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h6J3Lxa1",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ajRAKmwAK",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ajRAKmwAK",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ac0Xami2l",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ac0Xami2l",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h2yM6lKDT",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h2yM6lKDT",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c52OYJDToS",
    opacity: 1,
    fill: "#119a9a",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c52OYJDToS",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eaE0yxxf5y",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eaE0yxxf5y",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#khHeby3Jh",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#khHeby3Jh",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1IYnnxW8",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1IYnnxW8",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e2URkqvb57",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e2URkqvb57",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aieNZzIR1",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aieNZzIR1",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a9DYLsoKG",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a9DYLsoKG",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2SQHH73H1",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2SQHH73H1",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cUCHIciEE",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cUCHIciEE",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aARNB0e2",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aARNB0e2",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cwXuGQ2l",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cwXuGQ2l",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#abqJpldj6",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#abqJpldj6",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f1yO8CaXdi",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f1yO8CaXdi",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1BLALiyGh",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1BLALiyGh",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d7F40RQX9",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d7F40RQX9",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#baFVOqfbj",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#baFVOqfbj",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bquqRZPp",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bquqRZPp",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dEgeu8qRt",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dEgeu8qRt",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1Q1HsGIMu",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1Q1HsGIMu",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dag6wyWxm",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dag6wyWxm",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a168GNXIia",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a168GNXIia",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g2ocEyLNWF",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g2ocEyLNWF",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#abPRDOvk0",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#abPRDOvk0",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#czlF72qZ7",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#czlF72qZ7",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b203FYOTXp",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b203FYOTXp",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hoocz4s4Q",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hoocz4s4Q",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 0.26,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2lhgW6BpA",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2lhgW6BpA",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 0.26,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1YgGhd65q",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1YgGhd65q",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 0.26,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1hXbSTLaz",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1hXbSTLaz",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 0.26,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aenm9wvXP",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aenm9wvXP",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 0.26,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1S5DFe3h4",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1S5DFe3h4",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 0.26,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b89vliFkR",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b89vliFkR",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 0.26,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1rfFOpYgW",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1rfFOpYgW",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 0.26,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f99bhBsJyt",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f99bhBsJyt",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bOZCff5gB",
    opacity: 1,
    fill: "#e6e6e6",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bOZCff5gB",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1MkoFiOop",
    opacity: 1,
    fill: "#e6e6e6",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1MkoFiOop",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h417XxseJ3",
    opacity: 1,
    fill: "#e6e6e6",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h417XxseJ3",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eNM8x55t0",
    opacity: 1,
    fill: "#e6e6e6",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eNM8x55t0",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#apHjeM8Yx",
    opacity: 1,
    fill: "#e6e6e6",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#apHjeM8Yx",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dTLRutKyV",
    opacity: 1,
    fill: "#e6e6e6",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dTLRutKyV",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cbeiabNzm",
    opacity: 1,
    fill: "#dd052b",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cbeiabNzm",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 0.26,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#btaCazh2x",
    opacity: 1,
    fill: "#e6e6e6",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#btaCazh2x",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBobSecondary);
export default __webpack_public_path__ + "static/media/BobSecondary.78a2865984a343d18e5b7d47c5781663.svg";
export { ForwardRef as ReactComponent };